const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the add list users component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('addListUsers', ['Users', function(Users) {
  return {
    restrict: 'E',
    scope: {
      list: '=',
      update: '&?'
    },
    template: require('../../../templates/directives/cms/add-list-users.html'),
    controller: ['$scope', '$window', function ($scope, $window) {
      var self = this;

      self.helpers = {
        getLocation: function(user) {
          if (user && user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
            return user.linked_locations[0].name;
          }
          return '-----';
        },
        getDepartment: function(user) {
          if (user && user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
            return user.linked_departments[0].name;
          }
          return '-----';
        },
        getTeams: function(user) {
          if (user && user.linked_teams) {
            var steams = '';
            user.linked_teams.forEach(function (team) {
              steams += team.name + ',';
            });
            return steams.slice(-1);
          }
          return '-----';
        },
        getOrgLevel: function(user) {
          if (user && user.linked_org_level) {
            return user.linked_org_level.name;
          }
          return '-----';
        },
        getGrade: function(user) {
          if (user && user.linked_grade) {
            return user.linked_grade.name;
          }
          return '-----';
        }
      };

      self.queried = {
        show: false,
        allowNext: true,
        noMatch: false,
        users: [],
        query: {},
        getStandardQuery: function() {
          var q = {
            subresource: '',
            page: 1,
            per_page: 10,
            fields: '_id,first_name,last_name,email,full_name,role,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade,job_title,last_login,createdAt,hired,manager_email',
            'linked_locations-populate': 'name',
            'linked_departments-populate': 'name',
            'linked_teams-populate': 'name',
            'linked_org_level-populate': 'name',
            'linked_grade-populate': 'name'
          };
          return q;
        },
        onQuery: function(opts) {
          self.queried.query = self.queried.getStandardQuery();
          if (!opts || typeof opts === 'object' && !Object.keys(opts).length) {
            self.queried.noMatch = false;
            self.queried.load();
            return;
          }
          self.queried.noMatch = true;

          self.queried.query.page = 1;
          for (var key in opts) {
            self.queried.query[key] = opts[key];
          }

          self.queried.load();
        },
        load: function(denied) {
          self.queried.loading = true;
          self.queried.allowNext = true;
          Users.find(self.queried.query, function (users) {
            self.queried.loading = false;
            if (users.length < self.queried.query.per_page) {
              self.queried.allowNext = false;
              if (!users.length && self.queried.query.page > 1) {
                self.queried.query.page--;
                self.queried.load(true);
                return;
              }
            }
            self.queried.users = users;
            if (denied) {
              self.queried.allowNext = false;
            }
          }, function (error) {
            console.log('Error getting users:', error);
          });
        },
        nextPage: function() {
          if (!self.queried.allowNext) {
            return;
          }
          self.queried.query.page++;
          self.queried.load();
        },
        previousPage: function() {
          if (self.queried.query.page < 2) {
            return;
          }
          self.queried.query.page--;
          self.queried.load();
        }
      };

      self.selected = {
        users: [],
        isSelected: function(user) {
          if (!user || !user._id) {
            return false;
          }
          return $scope.list.indexOf(user._id) !== -1;
        },
        select: function(user) {
          if (!user || !user._id || self.selected.isSelected(user)) {
            return;
          }
          $scope.list.push(user._id);
          self.selected.load();
          if ($scope.update) {
            $scope.update();
          }
        },
        remove: function(user) {
          if (!user || !user._id || !$scope.list.length || !self.selected.isSelected(user)) {
            return;
          }
          for (var i = 0; i < $scope.list.length; i++) {
            if ($scope.list[i] === user._id) {
              $scope.list.splice(i, 1);
              self.selected.load();
              if ($scope.update) {
                $scope.update();
              }
              return;
            }
          }
        },
        load: function() {
          self.selected.loading = true;
          Users.find({
            subresource: '',
            page: 1,
            per_page: 20,
            fields: '_id,first_name,last_name,email,full_name,role,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade,job_title,last_login,createdAt,hired,manager_email',
            'linked_locations-populate': 'name',
            'linked_departments-populate': 'name',
            'linked_teams-populate': 'name',
            'linked_org_level-populate': 'name',
            'linked_grade-populate': 'name',
            _id: '$in,' + $scope.list.length + ',' + $scope.list.join(',')
          }, function (users) {
            self.selected.users = users;
            self.selected.loading = false;
          }, function (error) {
            console.log('Error getting users:', error);
          });
        }
      };

      self.initialize = function() {
        if (!$scope.list) {
          $scope.list = [];
        }

        self.queried.show = !$scope.list.length;
        self.selected.load();
      };

      self.initialize();
    }],
    controllerAs: 'userList'
  };
}]);